// src/features/scheduleBuilder/slices/claimRequestTotals/constants.ts
export const SLICE_NAME = 'claimRequestTotals';
export const PARENT_SLICE_NAME = 'scheduleBuilder';
